import "./about-me-page.scss";

type AboutMePageProps = {};

const AboutMePage = (props: AboutMePageProps) => {
  return (
    <>
      <div className="about-me-page page">
        <div className="about-me-page__image"></div>
        <h1 className="about-me-page__header page__header"></h1>
        <p className="about-me-page__my-moto">
          “Има два вида учители – такива, които те заливат с толкова много
          информация, че оставаш скован, и такива, които само с един малък
          подтик, ти вдъхват сила , с която можеш да скочиш чак до небето.“ -
          Робърт Фрос
        </p>
      </div>
    </>
  );
};

export default AboutMePage;
